import { Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { VesselOwner } from '@models';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input'

@Component({
  selector: 'app-vessel-owner-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  imports: [
    MatButtonModule,
    MatInputModule,
    MatDialogModule,
    ReactiveFormsModule,
  ],
})
export class VesselOwnerFormComponent {
  isEdit = signal<boolean>(false);
  dialogRef = inject<MatDialogRef<VesselOwnerFormComponent>>(MatDialogRef);

  name = new FormControl('', { validators:[Validators.required] });
  location = new FormControl('', {});
  ownerForm = new FormGroup({
    name: this.name,
    location: this.location,
  });

  constructor() {
    const owner = inject<VesselOwner>(MAT_DIALOG_DATA);

    this.isEdit.set(!!owner);

    if (owner) {
      if (owner.name) {
        this.name.setValue(owner.name);
      }

      if (owner.location) {
        this.location.setValue(owner.location);
      }
    }
  }

  submit() {
    if (this.ownerForm.pristine || !this.ownerForm.valid) { return };

    const data = {
      name: this.ownerForm.value.name,
      location: this.ownerForm.value.location ? this.ownerForm.value.location : undefined,
    } as VesselOwner;

    this.dialogRef.close(data);
  }

  cancel() {
    this.dialogRef.close();
  }
}
